import SocketHelper from 'utility/socket/SocketHelper'

import settings from 'settings'

export class RPSocketService extends SocketHelper {}

export default new RPSocketService(settings.rpSocketUrl)
